import axios from 'axios'
import { formatDateString } from './dates'

export async function getOnboardingSteps() {
    const response = await axios.get('/onboarding')
    return response.data
}
export async function fetchPeriodAnalysis () {
    const response = await axios.get('/period-analysis')
    return response.data
}
export async function fetchPhaseForDate(selectedDate, timezone = Intl.DateTimeFormat().resolvedOptions().timeZone) {
    const date = formatDateString(selectedDate)
    timezone = timezone.replace("/", "-")
    const response = await axios.get(`/period-phase/${date}/${timezone}`)
    return response.data
}